import { Observable, catchError, map, of } from 'rxjs';

import { UpdatableShippingOrder } from '../../../domain/models/update-order-shipping-link.models';
import { OrderRepositoyInterface } from '../../../domain/ports/secondary/order-repository.interface';

import { Address } from '@api/address/models/address.models';
import { LanguageId, StoreId } from '@core/domain/types';
import { ResultObject } from '@core/domain/types/result-object.type';

export function UpdateShippingAddressUseCase(
    orderRepository: OrderRepositoyInterface,
    storeId: StoreId,
    languageId: LanguageId,
    order: UpdatableShippingOrder,
    selectedAddress: Address
): Observable<ResultObject<any, undefined>> {
    return orderRepository.updateOrderShippingAddress(storeId, languageId, order, selectedAddress).pipe(
        map((result) => ({
            success: result.success,
            ...result.error !== undefined ? { error: result.error } : {},
        })),
        catchError((error) => {
            return of({
                success: false,
                error: {
                    desciption: error.message,
                },
            });
        })
    );
}
